/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Version_LabelInputs */

const en_us2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App version`)
};

const pt_br2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão do app`)
};

const es_419_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión de la app`)
};

const pt_pt2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão da app`)
};

const fr_fr2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version de l'app`)
};

const de_de2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Version`)
};

const it_it2_profile_version_label = /** @type {(inputs: Profile_Version_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione dell'app`)
};

/**
* | output |
* | --- |
* | "App version" |
*
* @param {Profile_Version_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_version_label = /** @type {((inputs?: Profile_Version_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Version_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_version_label(inputs)
	if (locale === "es-419") return es_419_profile_version_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_version_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_version_label(inputs)
	if (locale === "de-DE") return de_de2_profile_version_label(inputs)
	if (locale === "it-IT") return it_it2_profile_version_label(inputs)
	return en_us2_profile_version_label(inputs)
});
export { profile_version_label as "profile.version_label" }